<template lang="pug">
.CrisisEcharts
  .title 危机图谱
  .filter
    .filter_left_select
      .select(
        v-for="(option, i) in opts",
        :key="i",
        :class="{ checked: checked === option }",
        @click="choose(option)"
      ) {{ option }}
    .filter_left_more
      BaseMoreButton(path="/CrisisChart")
  BaseSankeyCharts(
    :link="chartList",
    style="height: 525px",
    :right="chartGridRight"
  )
</template>

<script>
import client from '@index/server/server'
import BaseMoreButton from '../components/BaseMoreButton'
import BaseSankeyCharts from '@index/components/BaseSankeyCharts'
export default {
  components: {
    BaseMoreButton,
    BaseSankeyCharts
  },
  computed: {
    chartGridRight () {
      return this.checked === '行业' ? 80 : 200
    }
  },
  data () {
    return {
      opts: ['行业', '风险'],
      checked: '行业',
      chartList: [],
      origin: {
        industryList: [],
        category: []
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      client.GetIndexGraph().then(res => {
        if (res.success) {
          const { category, industry } = res.data
          this.origin.industryList = industry
          this.origin.category = category
          this.initChartList()
        }
      })
    },
    choose (type) {
      this.checked = type
      this.initChartList()
    },
    initChartList () {
      const originList = this.checked === '行业' ? this.origin.industryList : this.origin.category
      const chartListNew = []
      originList.forEach(t => {
        chartListNew.push(...t.list.map(s => {
          if (this.checked === '行业') {
            return [t.category, s.priBrand, s.startTime]
          } else {
            return [t.brand, s.eventName, s.startTime]
          }
        }))
      })
      this.chartList = chartListNew.splice(0, 20)
    }
  }
}
</script>

<style lang="scss" scoped>
.CrisisEcharts {
  width: 535px;
  box-sizing: border-box;
  .title {
    font-size: 22px;
    color: #333333;
    margin-bottom: 33px;
  }
  .filter {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .filter_left_select {
      display: flex;
      align-items: center;
      border-radius: 4px;
      border: solid 1px #f1f3f7;
      width: 154px;
      height: 34px;
      line-height: 34px;
      cursor: pointer;

      .select {
        height: 100%;
        flex: 1;
        font-size: 16px;
        color: #999999;
        text-align: center;
        &.checked {
          background-color: #f1f3f7;
          color: #333333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/CrisisEcharts/CrisisEcharts.vue